import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  TextInput,
} from '@met/react-components';
import React, { useEffect, useRef, useState } from 'react';

const AddLanguageModal = ({ hidden, toggle, onSaveClick }) => {
  const [namespace, setNamespace] = useState('');
  const namespaceRef = useRef(null);

  useEffect(() => {
    if (!hidden) namespaceRef.current.focus();
  }, [hidden, namespaceRef]);

  const handleSaveClick = () => {
    onSaveClick(namespace)
      .then(() => setNamespace(''))
      .then(() => toggle());
  };

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  return (
    <Modal centered hidden={hidden} toggle={toggle}>
      <ModalContent>
        <ModalHeader toggle={toggle}>
          <FontAwesomeIcon icon='file' /> Add Namespace
        </ModalHeader>
        <ModalBody>
          <p>
            A namespace can be anything. It is just a logical grouping of
            translations.
          </p>
          <TextInput
            inputRef={namespaceRef}
            placeholder='Namespace Name'
            value={namespace}
            onKeyPress={handleKeyPress}
            onChange={e => setNamespace(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggle}>Close</Button>
          <Button primary onClick={handleSaveClick}>
            Save Changes
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddLanguageModal;
